import { render, staticRenderFns } from "./Videos.CarouselItem.vue?vue&type=template&id=75a647af&scoped=true"
import script from "./Videos.CarouselItem.vue?vue&type=script&lang=js"
export * from "./Videos.CarouselItem.vue?vue&type=script&lang=js"
import style0 from "./Videos.CarouselItem.vue?vue&type=style&index=0&id=75a647af&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a647af",
  null
  
)

export default component.exports